export const SHARED_POSTS_INFO_REQUESTED = 'SHARED_POSTS_INFO_REQUESTED'
export const SHARED_POSTS_INFO_SUCCESS = 'SHARED_POSTS_INFO_SUCCESS'
export const SHARED_POSTS_INFO_FAILED = 'SHARED_POSTS_INFO_FAILED'
